import {Component, Injector} from '@angular/core';
import {LogsService} from "./logs.service";
import {ColumnType, GeneralListComponent} from "../shared/general-list/general-list.component";

@Component({
    selector: 'app-logs',
    templateUrl: '../shared/general-list/general-list.component.html',
    standalone: false
})
export class LogsComponent extends GeneralListComponent {
  constructor(
    injector: Injector,
    private logService: LogsService,
  ) {
    super(injector);

    this.title = this.logService.getTranslation("LOGS");

    this.columns = [
      {id: 'id',label: "ID", type: ColumnType.Simple},
      {id: 'message',label: this.logService.getTranslation("MESSAGE"), type: ColumnType.Simple},
      {id: 'level',label: this.logService.getTranslation("LEVEL"), type: ColumnType.Simple},
      {id: 'classname',label: this.logService.getTranslation("CLASS"), type: ColumnType.Simple},
      {id: 'channel',label: this.logService.getTranslation("ENTITY_ID"), type: ColumnType.Simple},
      {id: 'modified',label: this.logService.getTranslation("MODIFIED"), type: ColumnType.Simple},
      {id: 'modifiedby',label: this.logService.getTranslation("MODIFIEDBY"), type: ColumnType.Simple},
    ];
  }

  fetchItems() {
    this.logService.getItems().subscribe((resp: any) => {
      if (resp && resp.length) {
        this.items = resp;
        this.dataSource.data = this.items;
      }
    })
  }
}
